import React from 'react';
import styled from 'styled-components';
import { InfoClientType, TInfoClient } from '../../../store/users/types';
import { removeMiddleName } from '../../../utils/removeMiddleName';

interface UserListProps {
  users: TInfoClient[] | InfoClientType[];
  onClick: (user: TInfoClient | InfoClientType) => void;
  onWrite: (user: TInfoClient | InfoClientType) => void;
}

export const UserList: React.FC<UserListProps> = React.memo(({ users, onClick, onWrite }) => {
  return (
    <UserListS>
      {users.map((u, i) => (
        <UserItem key={u.id2 + i} user={u} onClick={onClick} onWrite={onWrite} />
      ))}
    </UserListS>
  );
});

interface UserItemProps {
  user: TInfoClient | InfoClientType;
  onClick: (user: TInfoClient | InfoClientType) => void;
  onWrite: (user: TInfoClient | InfoClientType) => void;
}

const UserItem: React.FC<UserItemProps> = React.memo(({ user, onClick, onWrite }) => {
  return (
    <li>
      <BodyS>
        <Infos onClick={() => onClick(user)}>
          <IconS>
            {user.fio.split(' ')[0][0].toUpperCase()}
            {user.fio.split(' ')[1][0].toUpperCase()}
          </IconS>
          <NameS>{removeMiddleName(user.fio)}</NameS>
        </Infos>
        <div style={{ width: '80px' }}>
          <NameS style={{ color: 'rgba(26,130,197,1)', justifyContent: 'flex-end' }} onClick={() => onWrite(user)}>
            написати
          </NameS>
        </div>
      </BodyS>
    </li>
  );
});

const UserListS = styled.ul`
  padding: 0;
  margin: 0;

  li {
    display: flex;
    align-items: center;
    padding: 10px 0;
  }
`;

const BodyS = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  span {
    display: flex;
  }
`;

const Infos = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const IconS = styled.span`
  width: 30px;
  height: 30px;
  background: grey;
  color: white;
  border-radius: 50%;
  align-items: center;
  font-size: 12px;
  justify-content: center;
`;
const NameS = styled.span`
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 10px;
  font-size: 13px;
`;
